import styled from 'styled-components';

import backgroundImg from '../../assets/img/background.png';

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Banner = styled.div`
  .swiper-pagination-bullets {
    display: inline;
    margin-bottom: -15px;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.smoothBlue};
  }

  img {
    width: 100vw;
    /* height: 750px; */
    height: 77.4vh;
    margin-bottom: 22px;
  }

  .shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 -10px 10px -13px #000000;
    bottom: 22px;
  }

  .swiper-button-next {
    display: none;
  }

  .swiper-button-prev {
    display: none;
  }

  @media (max-width: 1600px) {
    img {
      height: 600px;
    }
  }

  @media (max-width: 920px) {
    img {
      height: auto;
    }
  }
`;

export const GamesContainer = styled.div`
  flex: 1;

  background-image: url(${backgroundImg});
  background-size: 100% auto;
  background-position: center;

  > h1 {
    font-size: 3rem;
    font-weight: 600;
    width: fit-content;
    color: ${({ theme }) => theme.green};

    margin: 0 auto 16px;
  }

  &::before {
    content: '';
    display: flex;
    height: 2px;
    width: 100%;
    background: ${({ theme }) => theme.menuBackground};

    margin: 8px 0 0;
  }
`;

export const GameList = styled.div`
  width: 100%;
  justify-items: center;
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 1fr));

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    margin-bottom: 15px;

    a {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 430px) {
    grid-template-columns: minmax(200px, 1fr);
  }

  a {
    position: relative;
    display: block;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1.2rem;
    font-weight: bold;
    height: 40px;
    letter-spacing: 0.1rem;
    text-align: center;
    color: ${({ theme }) => theme.text};
    min-width: 200px;
    background-color: ${({ theme }) => theme.purple};

    @media (min-width: 1400px) {
      min-width: 300px;
    }

    @media (max-width: 430px) {
      min-width: 80vw;
    }
  }

  a::before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      45deg,
      #3d8c4c,
      #888bc3,
      #8c5098,
      #d1a14c,
      #e66968,
      #3d8c4c,
      #888bc3,
      #8c5098,
      #d1a14c,
      #e66968
    );
    background-size: 400%;
    opacity: 0;
    transition: 0.5s;
    animation: animate 20s linear infinite;
  }

  a::after {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      45deg,
      #3d8c4c,
      #888bc3,
      #8c5098,
      #d1a14c,
      #e66968,
      #3d8c4c,
      #888bc3,
      #8c5098,
      #d1a14c,
      #e66968
    );
    background-size: 400%;
    opacity: 0;
    filter: blur(20px);
    transition: 0.5s;
    animation: animate 20s linear infinite;
  }

  a:hover::before,
  a:hover::after {
    opacity: 1;
  }

  @keyframes animate {
    0% {
      background-position: 0 0;
    }
    50% {
      background-position: 300% 0;
    }
    100% {
      background-position: 0 0;
    }
  }

  a span {
    position: relative;
    display: block;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    width: 196px;
    height: 36px;
    text-align: center;
    padding-top: 3px;
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    transition: 0.5s;
    z-index: 1;

    @media (min-width: 1400px) {
      min-width: calc(300px - 4px);
    }

    @media (max-width: 900px) {
      padding-top: 5px;
    }

    @media (max-width: 430px) {
      width: calc(80vw - 4px);
    }
  }
`;

export const Row = styled.div`
  .swiper-button-next {
    background-image: url('https://cdn-icons-png.flaticon.com/512/566/566006.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    transform: rotate(90deg);

    transition: all 0.5s;
    opacity: 0;
    visibility: hidden;
  }

  .swiper-button-prev {
    background-image: url('https://cdn-icons-png.flaticon.com/512/566/566006.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    transform: rotate(-90deg);
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s;
  }

  .swiper-button-next::after {
    display: none;
  }

  .swiper-button-prev::after {
    display: none;
  }

  .swiper-pagination-bullets {
    display: none;
  }

  h2 {
    margin-left: 90px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
  }

  @media (min-width: 821px) {
    &:hover {
      .swiper-button-next {
        opacity: 1;
        visibility: visible;
        -moz-animation-delay: 0.5s;
        -webkit-animation-delay: 0.5s;
        -o-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }

      .swiper-button-prev {
        opacity: 1;
        visibility: visible;
        -moz-animation-delay: 0.5s;
        -webkit-animation-delay: 0.5s;
        -o-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }
    }
  }

  @media (max-width: 400px) {
    h2 {
      margin-left: 35px;
    }
  }
`;
